export const StrataBelowRefChoices = [
  { value: "na", text: "N/A", graphText: (depth: number) => "" },
  {
    value: "abandoned",
    text: "Abandoned",
    graphText: (depth: number) => `Trial pit abandoned at ${depth}mm`
  },
  {
    value: "boreHole",
    text: "Bore Hole",
    graphText: (depth: number) =>
      `For strata below ${depth}mm see bore hole log`
  },
  {
    value: "pitEnds",
    text: "Pit Ends",
    graphText: (depth: number) => `Pit ends at ${depth}mm`
  }
];
